import Service from '@ember/service';
import { service } from '@ember/service';

export default class ComponentManager extends Service {
    @service hashDataService;

    adcInputs = null;
    driverInputs = null;
    signalInputs = null;
    filterInputs = null;

    initialLoadWithHash() {
        this.runComponentsWithHash([this.adcInputs, this.signalInputs, this.driverInputs, this.filterInputs]);

        this.noisePanelInitialLoad();
    }

    initialLoadWithoutHash() {
        this.runComponentsWithoutHash([this.adcInputs, this.signalInputs, this.driverInputs, this.filterInputs]);

        this.noisePanelInitialLoad();
    }

    noisePanelInitialLoad() {
        this.hashDataService.setOptionalSourceSettingsProperties(/**initialLoad=*/ true);
        this.hashDataService.setUrlParameter('model.showOptionalSourceSettings');
        this.hashDataService.setUrlParameter('model.wbNoise');
        this.hashDataService.setUrlParameter('model.thd');
    }

    runComponentsWithHash(components) {
        components.forEach((component) => {
            if (component && 'initialLoadWithHash' in component) component.initialLoadWithHash();
        });
    }

    runComponentsWithoutHash(components) {
        components.forEach((component) => {
            if (component && 'initialLoadWithoutHash' in component) component.initialLoadWithoutHash();
        });
    }
}
